import { Directive, ElementRef, Input, Host, Optional, Self } from "@angular/core";
import { NativeDesktopSupport } from "../native-desktop-support";
import { BfxCalendarComponent } from "../../order-entry/interface/controls/good-from-until/bfx-calendar.component";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import {
  DomHandlerMode,
  DOM_HANDLER_MODE_TOKEN,
  DomHandlerService,
  DomHandler,
} from "@bfx/primeng/dom";
import { Calendar } from "@bfx/primeng/calendar";
import { Subscription } from "rxjs";
import { NativeDesktopWindow } from "../../../shared/native-desktop/NativeDesktopWindow";
const GL_HEADER = 40;

@Directive({
  selector: "[ownerDocumentPCalendar]",
  providers: [
    {
      provide: DOM_HANDLER_MODE_TOKEN,
      useFactory: () => {
        if (NativeDesktopSupport.isNativeDesktopContainer())
          return new DomHandlerService(DomHandlerMode.NativeContainer);
        return new DomHandlerService(DomHandlerMode.Browser);
      },
    },
  ],
  standalone: false,
})
export class OwnerDocumentPCalendar {
  public static _calendarWindow: NativeDesktopWindow;
  public static _calendarDropdownOpen: boolean = false;
  public static _activeComponent: BfxCalendarComponent;

  @Input("ownerDocumentPCalendar")
  public target: string;
  hideSubscription: Subscription;

  constructor(@Host() @Self() @Optional() component: Calendar, element: ElementRef) {
    this.initialize(component, element);
  }

  private initialize(component: Calendar, element: ElementRef): void {
    // if (NativeDesktopSupport.isNativeDesktopContainer()) {
    if (component instanceof Calendar) {
      let calendar: Calendar = component as Calendar;

      const onOverlayHideFn = calendar.onOverlayHide;
      calendar.onOverlayHide = () => {
        onOverlayHideFn.call(calendar);
      };

      const alignOverlayFn = calendar.alignOverlay;
      calendar.alignOverlay = () => {
        if (calendar.appendTo) {
          let min = GL_HEADER * NativeDesktopSupport.zoomLevel;
          let top = 0;

          DomHandler.absolutePosition(calendar.overlay, calendar.inputfieldViewChild.nativeElement);
          top = parseFloat(getComputedStyle(calendar.overlay).getPropertyValue("top"));
          top = Math.max(top, min);
          calendar.overlay.style.top = top + "px";
        } else {
          DomHandler.relativePosition(calendar.overlay, calendar.inputfieldViewChild.nativeElement);
        }
      };

      if (calendar.documentClickListener != null) {
        calendar.renderer.listen(
          element.nativeElement.ownerDocument.body,
          "click",
          calendar.documentClickListener,
        );
      }
    }
    // }
  }
}
